<template>
  <div id="login">
    <div class="login-wrap">
		<h2>麒麟软件账号登录</h2>
		<ul class="login-ul">
			<li>
				<input type="text" v-model="username" placeholder="邮件地址/账号"/>
			</li>
			<li>
				<input type="password" v-model="password" placeholder="密码"/>
			</li>
			<li class="ub w100 ub-ac code-box">
				<div class="ub ub-f1">
					<input style="width:100%;" type="text" v-model="code" placeholder="验证码"/>
				</div>
				<div class="code h100">
					<el-button style="width:100%;height:100%;" @click="sendVerificationCode" :disabled="countdown > 0">
						{{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}
					</el-button>
				</div>
				
			</li>
		</ul>
		<el-button :loading="isSubmiting" :disabled="isSubmiting" class="login-btn" type="danger"  @click="toLoginBtn">{{ loginText }}</el-button>
		<div class="login-tips clearfix">
			<a :href="registerUrl" target="_blank">注册</a>
			<span class="login-line"></span>
			<a :href="passwordUrl"  target="_blank">忘记密码</a>
		</div>
	</div>
  </div>
</template>

<script>
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
export default {
  name: 'login',
  data(){
	return {
		loginText:'登 录',
		isSubmiting:false,
		username: '',   //登录用户名
		password: '', //密码
		code: '', //图形验证码
		imageCodeSrc: '', //图形验证码图片地址
		registerUrl: 'https://id.kylinos.cn/registered?userSource=forum&redirectUrl=https://gongece.kylinos.cn',
		returnUrl: '',
		passwordUrl: 'https://id.kylinos.cn/find?userSource=forum&redirectUrl=https://gongece.kylinos.cn',
		activityType: 1,
		activeInfo: {},
		countdown: 0, // 初始倒计时时间
        intervalId: null, // 存储interval的id
	}
  },
  beforeDestroy(){
	if(this.intervalId){
		clearInterval(this.intervalId);
		this.intervalId = null
	}
  },
  methods: {
	startCountdown() {
        this.countdown = 60; // 假设倒计时60秒
        this.intervalId = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown -= 1;
          } else {
            clearInterval(this.intervalId);
          }
        }, 1000);
      },
      sendVerificationCode() {
		if(!this.username) {
			this.$message.error('用户名不能为空')
			return
		}
        // 开始倒计时
        this.startCountdown();
		this.getImageCode() 
      },
	toLoginBtn(){
		let username = this.username
		let password = this.password
		let code = this.code
		if(!username) {
			this.$message.error('用户名不能为空')
			return
		}
		if(!password) {
			this.$message.error('请输入您的密码')
			return
		}
		if(!code) {
			this.$message.error('请输入验证码')
			return
		}
		this.toLogin()
	},
	async toLogin(){
		// let url = 'v1/user/doLogin'
		let url = 'v1/user/idUserLogin'
		let param = {
			userName: this.username,
			password: this.password,
			code: this.code
		}
		this.isSubmiting = true
		this.loginText = '登录中'
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			//存储登录信息
			localStorage.setItem('user',JSON.stringify(res.data.entity))
			localStorage.setItem('userId', res.data.entity.id)
			localStorage.setItem('token', res.data.entity.token)
			localStorage.setItem('uuid', res.data.entity.uuid)
			this.bus.$emit('resfreshheaPic')
			this.$router.go(-1)
		} else {
			this.isSubmiting = false
			this.loginText = '登 录'
			this.$message.error(res.data.msg)
		}
	},
	async getImageCode() {
		// let param = {}
		// let url = 'v1/user/getMCodeImage'
		
		let param = {
			userName:this.username
		}
		let url = 'v1/user/getIdCode'
		const res = await post(url, param)
		if(res?.data?.code==='200'){
			this.$message.success(res.data.entity.message)
		}else{
			this.$message.error(res.data.message)
		}
		console.log(res,'0000000000')
		// this.$message.error('请输入图形验证码')
	},
	async getRedirectUrl() {
		let param = {
			code: 'QILIN-ID-REDIRECT-LOGIN'
		}
		const res = await post('/v1/sysConfig/getConfigByCode', qs.stringify(param))
		if(res.data.code==200) {
			this.returnUrl = res.data.entity.configValue
			this.registerUrl = this.registerUrl+ this.returnUrl
			this.passwordUrl = this.passwordUrl+ this.returnUrl
		}
	}
  },
}
</script>

<style lang="less" scoped>
	#login{
		background: #fff;
		overflow: hidden;
	}
	.login-wrap{
		width: 30%;
		margin: 60px auto 30px;
		h2{
			padding-bottom: 40px;
			font-size: 32px;
			line-height: 47px;
			font-weight: 400;
			text-align: center;
		}
		.login-ul{
			li{
				margin-top: 20px;
				border-radius: 6px;
				background:#f7f7f7;
				padding-left: 40px;
				height: 48px;
				position: relative;
				box-sizing: border-box;
				&.code-box{
					position: relative;
					.code{
						width:130px;
						position: absolute;
						right:0;
						top:0;
					}
				}
				input{
					width: 100%;
				    height: 100%;
					font-size: 14px;
					line-height: 48px;
					color: #333;
					background: none
				}
				.code-btn{
					position: absolute;
					right:0;
					top:0;
					height: 48px;
					right: 20px;
					line-height: 48px;
				}
			}
		}
		
		.login-btn{
			display: block;
			width: 100%;
			height: 48px;
			margin:60px auto 30px;
			background: #DE0515;
			border-color: #DE0515;
			border-radius: 6px;
			text-align: center;
			color:#fff;
			line-height: 48px;
			font-size: 23px;
			transition: all .3s;
			&:hover{
				background: #f78989;
				border-color: #f78989;
			}
			&.is-disabled{
				background: #f78989;
				border-color: #f78989;
			}
			
		}
	
		.login-tips{
			width:130px;
			margin: 0 auto;
			text-align: center;
			a{
				float:left;
				height:20px;
				color:#007DFF;
				line-height: 18px;
				&:hover{
					opacity: .6;
				}
			}
			.login-line{
				float: left;
				width: 1px;
				height: 18px;
				margin: 0 20px;
				background: #e5e5e5;
			}
		}
	}
</style>
